import swal from 'sweetalert2'

export const ErrorsCallback = (text, callback) => {
  swal({
    title: 'ผิดพลาด',
    text: text,
    type: 'error',
    focusConfirm:false,
    confirmButtonText: 'ทราบ',
    confirmButtonColor:"#ff3d00"
  }).then(result => {
    if (result.value) {
      if (callback) {
        callback()
      }
    }
  })
}
